import React, { useContext } from 'react'
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import { toast } from 'react-toastify'

import { AuthContext } from './context/auth-context'
import Navigation from './components/Navigation/Navigation'
import Auth from './components/Auth/Auth'
import Vehicles from './components/Vehicles'
import Branches from './components/Branches'
import Map from './components/Map'

import { MainContentStyles } from './styled'

toast.configure()

const App = () => {
  const authContext = useContext(AuthContext)

  return (
    <BrowserRouter>
      <Navigation />
      <MainContentStyles>
        <Switch>
          {authContext.token && <Route path='/map' component={Map} />}
          {authContext.token && <Route path='/vehicles' component={Vehicles} />}
          {authContext.token && <Route path='/branches' component={Branches} />}
          {authContext.token && <Redirect from='/' to='/vehicles' />}

          {!authContext.token && <Route path='/auth' component={Auth} />}
          {!authContext.token && <Redirect from='/' to='/auth' />}
        </Switch>
      </MainContentStyles>
    </BrowserRouter>
  )
}

export default App
